import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap, Users, UserCheck, School, ShieldCheck } from "lucide-react";

const STATS = [
    { key: "students_count", label: "عدد الطالبات", icon: GraduationCap, color: "text-[#1B2A4E]", bg: "bg-slate-100" },
    { key: "parents_count", label: "أولياء الأمور", icon: Users, color: "text-[#1B2A4E]", bg: "bg-slate-100" },
    { key: "trainers_count", label: "المدربات", icon: UserCheck, color: "text-[#C8102E]", bg: "bg-[#FFF1F2]" },
    { key: "classes_count", label: "الفصول", icon: School, color: "text-[#1B2A4E]", bg: "bg-slate-100" },
    { key: "active_users", label: "حسابات نشطة", icon: ShieldCheck, color: "text-emerald-600", bg: "bg-emerald-50" },
];

export default function Overview() {
    const [s, setS] = useState({});
    useEffect(() => { api.get("/admin/overview").then((r) => setS(r.data)).catch(() => {}); }, []);
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-[#0F172A]">لوحة التحليلات العامة</h1>
                <p className="text-sm text-slate-500 mt-1">ملخص فوري لحالة المنظومة</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 stagger-in">
                {STATS.map((it) => (
                    <div key={it.key} data-testid={`stat-${it.key}`} className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
                        <div className={`w-10 h-10 rounded-lg ${it.bg} ${it.color} flex items-center justify-center mb-3`}>
                            <it.icon className="w-5 h-5" />
                        </div>
                        <div className="text-3xl font-bold text-[#0F172A] font-mono-num">{s[it.key] ?? "-"}</div>
                        <div className="text-xs text-slate-500 mt-1">{it.label}</div>
                    </div>
                ))}
            </div>
            <div className="bg-white rounded-xl border border-slate-200 p-6">
                <h3 className="font-semibold text-[#0F172A] mb-2">ابدأي من هنا</h3>
                <ul className="text-sm text-slate-600 space-y-2 list-disc pr-5">
                    <li>ارفعي ملف Excel للطالبات من صفحة <span className="font-semibold text-[#1B2A4E]">استيراد ملفات Excel</span></li>
                    <li>ستُنشأ حسابات الطالبات وأولياء الأمور تلقائياً بعد التأكيد</li>
                    <li>يمكنك إعادة تعيين كلمات المرور من صفحات الحسابات</li>
                </ul>
            </div>
        </div>
    );
}
